
const ONE_POUND_IN_KG: number = 0.45359237
const ONE_KG_IN_POUNDS: number = 2.20462262

const ONE_CM_IN_INCHES: number = 0.393701
const ONE_INCHES_IN_CM: number = 2.54

export enum WeightUnit {
  KG = 'kg',
  LBS = 'lbs'
}
export enum LengthUnit {
  CM = 'cm',
  IN = 'in'
}

export function convertToKg (value, measuringUnit: WeightUnit) {
  if (measuringUnit.toLowerCase() === WeightUnit.KG) return value
  return value * ONE_POUND_IN_KG
}

export function convertToCM (value, measuringUnit: LengthUnit) {
  if (measuringUnit.toLowerCase() === LengthUnit.CM) return value
  return value * ONE_INCHES_IN_CM
}

export function convertWeightForDisplaying (value, measuringUnit: WeightUnit, noOfDecimals: number = 2) {
  if (!value) return null
  if (measuringUnit.toLowerCase() === WeightUnit.LBS) {
    value = value * ONE_KG_IN_POUNDS
  }
  const noOfDigits = value.toString().split('.')[0].length

  return parseFloat(value.toPrecision(noOfDigits + noOfDecimals))
}

export function convertLengthForDisplaying (value, measuringUnit: LengthUnit, noOfDecimals: number = 2) {
  if (!value) return null
  if (measuringUnit.toLowerCase() === LengthUnit.IN) {
    value = value * ONE_CM_IN_INCHES
  }
  const noOfDigits = value.toString().split('.')[0].length

  return parseFloat(value.toPrecision(noOfDigits + noOfDecimals))
}
